var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3686 0C7.86628 0 0.973877 6.89241 0.973877 15.3948C0.973877 23.8971 7.86628 30.7895 16.3686 30.7895C24.8709 30.7895 31.7634 23.8971 31.7634 15.3948C31.7633 6.89241 24.8708 0 16.3686 0ZM12.2613 22.8374H8.88119V11.9174H12.2613V22.8374ZM10.5551 10.4873C9.45123 10.4873 8.55633 9.5851 8.55633 8.47236C8.55633 7.3595 9.45135 6.45736 10.5551 6.45736C11.6589 6.45736 12.5538 7.3595 12.5538 8.47236C12.5539 9.58516 11.659 10.4873 10.5551 10.4873ZM24.9281 22.8374H21.5644V17.1053C21.5644 15.5331 20.9672 14.6556 19.7241 14.6556C18.3711 14.6556 17.6643 15.5696 17.6643 17.1053V22.8374H14.4224V11.9174H17.6643V13.3881C17.6643 13.3881 18.6395 11.5843 20.955 11.5843C23.2705 11.5843 24.9281 12.9981 24.9281 15.923L24.9281 22.8374Z",
    fill: "#43B4E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.a6372a5f69a19955f5fa79510fd2434e.svg";
export { ForwardRef as ReactComponent };